import React from "react"
import Navbar from "../../Common/Navbar"
import Footer from "../../Common/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import HelpComp from "./Component/HelpComp"


const Help =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <HelpComp />
        </div>
        <Footer />
        </>
    )
}

export default Help